import { Api_Plugin } from '../plugins/api.js';
import { ToastPlugin } from '../plugins/toast.js';
import { EstadosPlugin } from '../plugins/estados_plugin.js';
import { DatePlugin } from '../plugins/date_plugin.js';
import { PhoneValidatorPlugin } from '../plugins/PhoneValidator.js';

export default (app) => {
    app.use(
        Api_Plugin({
        })
    );
    app.use(
        ToastPlugin({
        })
    );
    app.use(
        EstadosPlugin({
        })
    );
    app.use(
        DatePlugin({
        })
    );
    app.use(
        PhoneValidatorPlugin({
        })
    );
}